// Election posts used by plans, voter signs and polling schedules.
// Send exactly these values; any other returns 422.
export type ElectionCategory = 'wardpanch' | 'sarpanch' | 'panchayat_samiti' | 'zila_parishad';

// Listed in the order the backend stores them (polling schedule categories keep this order)
export const ELECTION_CATEGORIES: { value: ElectionCategory; label: string }[] = [
  { value: 'wardpanch', label: 'Ward Panch' },
  { value: 'sarpanch', label: 'Sarpanch' },
  { value: 'panchayat_samiti', label: 'Panchayat Samiti' },
  { value: 'zila_parishad', label: 'Zila Parishad' },
];

export const getCategoryLabel = (category: string | null | undefined) =>
  ELECTION_CATEGORIES.find((c) => c.value === category)?.label || category || null;
